module.exports = __webpack_public_path__ + "img/edge_restauration_restaurant_gastronomique.6e3f28c8.svg";